module.exports = __webpack_public_path__ + "media/categories/203-2e3a72b2.svg";